import type { EntityId, Team, TeamScore } from '../types';

export type MatchRosterLatencyQuality = 'good' | 'fair' | 'poor';

export interface MatchRosterEntry {
  readonly entityId: EntityId;
  readonly displayName: string;
  readonly team: Team;
  readonly isLocal: boolean;
  readonly latencyMs: number | null;
  readonly latencySource?: 'remote' | 'local' | null;
}

export interface MatchRosterState {
  readonly visible: boolean;
  readonly score: TeamScore;
  readonly entries: readonly MatchRosterEntry[];
}

export function matchRosterLatencyQuality(latencyMs: number): MatchRosterLatencyQuality {
  if (latencyMs < 85) return 'good';
  if (latencyMs < 150) return 'fair';
  return 'poor';
}
